import Vue from 'vue';

export default Vue.extend({
  props: ['confirmProgress', 'actionProgress'],
  data() {
    return {
      progressIndex: 0,
    };
  },
  created() {
    this.$store.commit('SET_CURRENT_STEP', this.confirmProgress[0]);
    this.checkRxCheckShouldSkip();
  },
  mounted() {
  },
  methods: {
    resetProgress() {
      console.log('reset progress');
      this.progressIndex = 0;
    },
    nextProgress() {
      console.log('next progress');
      this.progressIndex += 1;
    },
    checkRxCheckShouldSkip() {
      console.log(this.currentProgress, this.$store.getters.selectedDrug.rx_check);
      if (this.currentProgress === 'rxCheck') {
        console.log('med need rxcheck: ', this.$store.getters.selectedDrug.rx_check);
        if (this.$store.getters.selectedDrug.rx_check === false) {
          this.nextProgress();
        }
      }
    },
  },
  computed: {
    currentSystem() {
      return this.$store.getters.currentSystem;
    },
    currentDrugInDevice() {
      return this.$store.state.drugInDevice.currentDrugInDevice;
    },
    currentDevice() {
      return this.$store.state.device.currentDevice;
    },
    currentProgress() {
      return this.confirmProgress[this.progressIndex];
    },
    currentSchedule() {
      return this.$store.getters.currentSchedule;
    },
    currentDrug() {
      return this.$store.getters.currentDrug;
    },
    currentEvent() {
      return this.$store.state.event.currentEvent;
    },
    selectedDrugTotalAmount() {
      return this.$store.state.drug.selectedDrugTotalAmount;
    },
    instance() {
      return this.$store.state.instance;
    },
  },
  watch: {
    currentProgress(val) {
      console.log(val);
      this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
      this.checkRxCheckShouldSkip();
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/ComponentBase/ConfirmFlowBase.js